import { ReactComponent as Badge } from "./badge.svg";

const BadgeIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <Badge {...props} />;

export default BadgeIcon;
